import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import GroupedArticleIndexPageResultsSection, {
  GroupedArticleIndexPageResultsSectionProps,
} from './GroupedArticleIndexPageResultsSection';

const GroupedArticleIndexPageResultsSectionLight: React.FC<
  GroupedArticleIndexPageResultsSectionProps
> = (props) => {
  return <GroupedArticleIndexPageResultsSection {...props} />;
};

export default memo(
  withBlokWrapper(GroupedArticleIndexPageResultsSectionLight, Theme.ALT)
);
